export const MICROSOFT_ENTRA_PROVIDER_TYPE = "MICROSOFT_ENTRA";

const trim = (value) => (value == null ? "" : String(value).trim());

export const isDiscoveryUrlOnlyProvider = (provider) => {
    return !trim(provider?.tenant_id) && !!trim(provider?.discovery_url);
};

export const buildAccountSsoProviderPayload = ({
                                                    form,
                                                    includeTenantId = true,
                                                }) => {
    const payload = {
        provider_type: MICROSOFT_ENTRA_PROVIDER_TYPE,
        enabled: Boolean(form?.enabled),
        display_name: trim(form?.displayName),
        login_slug: trim(form?.loginSlug),
        client_id: trim(form?.clientId),
    };

    if (includeTenantId) {
        payload.tenant_id = trim(form?.tenantId);
    } else if (trim(form?.tenantId)) {
        payload.tenant_id = trim(form?.tenantId);
    }

    if (trim(form?.clientSecret)) {
        payload.client_secret = form.clientSecret;
    }

    return payload;
};

export const providerToForm = (provider) => ({
    enabled: provider?.enabled !== false,
    displayName: provider?.display_name || "Microsoft Entra",
    loginSlug: provider?.login_slug || "",
    tenantId: provider?.tenant_id || "",
    clientId: provider?.client_id || "",
    clientSecret: "",
});

export const buildCustomerSsoUrl = (origin, persistedLoginSlug) => {
    const slug = trim(persistedLoginSlug);
    if (!slug) {
        return "";
    }

    return `${trim(origin).replace(/\/+$/, "")}/sso/${encodeURIComponent(slug)}`;
};
